const INTERNAL_TEAMS = new Set(['Synvya'])

export function isInternalTeam(name: string): boolean {
  return INTERNAL_TEAMS.has(name)
}
